import {
	PARTNER_MODULE_ALLOCATION_SUCCESS,
	PARTNER_MODULE_ALLOCATION_FAILED,
	RESET_PARTNER_MODULE_ALLOCATION,
	LOADING_PARTNER_MODULE_ALLOCATION,
	NETWORK_ERROR_PARTNER_MODULE_ALLOCATION
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_PARTNER_MODULE_ALLOCATION:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {}
			};
		case PARTNER_MODULE_ALLOCATION_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload
			};
		case PARTNER_MODULE_ALLOCATION_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload
			};
		case NETWORK_ERROR_PARTNER_MODULE_ALLOCATION:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {}
			};
		case RESET_PARTNER_MODULE_ALLOCATION:
			return (state = initialState);
		default:
			return state;
	}
};
